import Box from '@/components/UI/box/Box';
import styles from './PriceSlider.module.scss';
import Slider from '@/components/UI/slider/Slider';
import Typography from '@/components/UI/typography/Typography';
import { Control, Controller } from 'react-hook-form';
import { PriceRangeData } from '../../MidTermPriceRange';
import { FC } from 'react';
interface PriceSliderProps {
  control: Control<PriceRangeData>;
}
const PriceSlider: FC<PriceSliderProps> = ({
  control
}) => {
  const [min, max] = [100_000, 300_000_000];
  return <Box className={styles['price-range-slider']} data-sentry-element="Box" data-sentry-component="PriceSlider" data-sentry-source-file="PriceSlider.tsx">
      <Controller name={'price'} control={control} render={({
      field: {
        value,
        onChange,
        ...props
      }
    }) => <Slider value={value || [min, max]} onChange={newValue => onChange(newValue)} min={min} max={max} step={1000000} {...props} />} data-sentry-element="Controller" data-sentry-source-file="PriceSlider.tsx" />
      <Box className={styles['min-max-price-text']} data-sentry-element="Box" data-sentry-source-file="PriceSlider.tsx">
        <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="PriceSlider.tsx">گران‌ترین</Typography>
        <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="PriceSlider.tsx">ارزان‌ترین</Typography>
      </Box>
    </Box>;
};
export default PriceSlider;